import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const circularProgressFullScreenComponent = {
  root: 'circular-progress-full-screen.root',
} as const satisfies ComponentLocatorMap;
